// =======================================================
// Variables
// =======================================================

// Const Global
const body              = document.querySelector('body');
const menu              = document.querySelector('#js-NavMain');
const logo              = document.querySelector('#js-Logo');
const menuLinks         = document.querySelectorAll('#js-NavMain .menu__link');
let   menuItems         = document.querySelectorAll('#js-NavMain .menu__item.menu-item-has-children');
let   subMenuItems      = document.querySelectorAll('#js-NavMain .menu__item.menu-item-has-children.js-active-submenu .submenu__item');

// Const Simple Menu
const menuSimple        = menu.classList.contains('nav-main--simple');
const menuOpen          = document.querySelector('#js-OpenMenu');
const menuClose         = document.querySelector('#js-CloseMenu');
const subMenuCloses     = document.querySelectorAll('.nav-main .submenu__close');

// Const Burger Menu
const menuBurger        = menu.classList.contains('nav-main--burger');
const menuOpenClose     = document.querySelector('#js-OpenCloseMenu');
const menuCloseA11y     = document.querySelector('#js-CloseMenuA11y');
const subMenuClose      = document.querySelector('#js-CloseSubmenu');
const buttonscontainer  = document.querySelector('.nav-main-buttons');



// =======================================================
// Simple responsive Menu
// =======================================================
if (menuSimple) {

    // Check if condition
    // console.log('If classlist contains nav-main--simple');

    // Open menu
    menuOpen.addEventListener('click', function () {
        menu.classList.add('js-active-menu');
        body.classList.add('js-active-navmain');
    });

    // Close menu
    menuClose.addEventListener('click', function () {
        menu.classList.remove('js-active-menu');
        body.classList.remove('js-active-navmain');
    });

    if(window.innerWidth > 960){
        // Open submenu
        menuItems.forEach(function (menuItem) {

            menuItem.addEventListener('click', function () {

                document.querySelectorAll('.submenu__link').forEach(x => x.tabIndex = -1);

                if (menuItem.classList.contains('js-active-submenu')) {
                    menuItem.classList.remove('js-active-submenu');
                    menu.classList.remove('js-SubOpen');
                    logo.classList.remove('js-LogoSubMenu');
                }
                else {
                    menuItem.classList.add('js-active-submenu');
                    menu.classList.add('js-SubOpen');
                    logo.classList.add('js-LogoSubMenu');
                    document.querySelectorAll('.js-active-submenu .submenu__link').forEach(x => x.tabIndex = 0);
                }

                menuItems.forEach(function (element) {
                    if(element !== menuItem ){
                        element.classList.remove('js-active-submenu')
                        document.querySelectorAll('.submenu__link').forEach(x => x.tabIndex = -1);
                        document.querySelectorAll('.js-active-submenu .submenu__link').forEach(x => x.tabIndex = 0);
                    }
                })
            });
        });
    }
    else {
        // Open submenu
        menuLinks.forEach(function (menuLink) {
            menuLink.addEventListener('click', function () {
                this.parentElement.classList.add('js-active-submenu');
                // Check added class
                // console.log("Add js-active-submenu");
            });
    
        });
    }

    // Close submenu
    subMenuCloses.forEach(function (subMenuClose) {
        subMenuClose.addEventListener('click', function () {
            document.querySelectorAll('.menu__item').forEach(x => x.classList.remove('js-active-submenu'));
            // Check deleted class
            // console.log("Remove js-active-submenu");
        });
    });

}


// ---------------------------------------------------
// ADD SPAN ON MENU ITEM
// ---------------------------------------------------

let menuEntry = document.getElementsByClassName('menu__link');
let firstEntry = menuLinks[0].innerHTML;
let secondEntry = menuLinks[1].innerHTML;
let thirdEntry = menuLinks[2].innerHTML;
let fourthEntry = menuLinks[3].innerHTML;

const firstArray = firstEntry.split(" ");
const secondArray = secondEntry.split(" ");
const thirdArray = thirdEntry.split(" ");
const fourthArray = fourthEntry.split(" ");

let firstFilter= firstArray.filter(Boolean);
let secondFilter= secondArray.filter(Boolean);
let thirdFilter= thirdArray.filter(Boolean);
let fourthFilter= fourthArray.filter(Boolean);

menuLinks[0].innerHTML = firstFilter[1] + '<span class="menu__label">' + firstFilter[2] + '</span>';
menuLinks[1].innerHTML = secondFilter[1] + '<span class="menu__label">' + secondFilter[2] + '</span>';
menuLinks[2].innerHTML = thirdFilter[1] + '<span class="menu__label">' +  thirdFilter[2] + " " + thirdFilter[3] + '</span>';
menuLinks[3].innerHTML = fourthFilter[1] + " " + fourthFilter[2] + '<span class="menu__label">' + fourthFilter[3] + " " + fourthFilter[4] + '</span>';
